export const setInstituteId = (payload) => ({
	type: "INSTITUTE_ID",
	payload,
});
